export const API = {
  Token: "/token",
  Logout: "/logout",
};
